// @ts-strict-ignore
import { ProductType } from '@/shared/types/product'

import { TCartItem } from '../types/cart-item'

import { isServiceHasProduct } from './isServiceHasProduct'

/**
 * Calculates the total number of service in the basket
 * @param cartItems
 */
export const getCartServicesCount = (cartItems: TCartItem[]): number => {
	let currentItemServicesCount = 0

	cartItems.forEach(cartItem => {
		if (cartItem.TYPE_PRODUCTS === ProductType.Service && isServiceHasProduct(cartItems, cartItem.RELATED_PRODUCTS)) {
			currentItemServicesCount += cartItem.QUANTITY
		}
	})

	return currentItemServicesCount
}
